import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Platform} from 'react-native';
import {useMutation} from 'react-query';
import {useDispatch, useSelector} from 'react-redux';
import {getModal} from '../../actions/modal';
import {getNotification} from '../../actions/notice';
import {getUser} from '../../actions/user';
import {getVehicle} from '../../actions/vehicle';
import {getVehicleslist} from '../../actions/vehicleslist';
import {isWeb} from '../../constants';
import HTMLTitle from '../../constants/HTMLTitle';
import {useLocation} from '../../imports/Router';
import Helmet from '../../imports/helmet';
import SyncTime from '../../imports/sync-time';
import {useApi} from '../../providers/ApiProvider';
import {selecetusertype} from '../../selectors/User';
import DeepLink from '../../services/deeplink/Deeplink';
import HideLoading from '../../utils/HideLoading';
import useVehiclesList from '../../utils/VehiclesList';
import {getMap} from '../../actions/map';
import {checkPermitionAndGetPosition} from '../../utils/location';

const UIWrapper = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {t} = useTranslation();
  const {api} = useApi();
  const {startReloadVehicleList, reloadVehicleList, stopReloadVehicleList} =
    useVehiclesList();
  const {isLearnNotifVisible, userStatus, isFirstOpen, token} = useSelector(
    state => selecetusertype(state),
  );
  const [notifications, setNotifications] = useState(null);

  const vehiclesMutation = useMutation({
    mutationFn: async params => {
      return api.vehicles(params);
    },
  });

  DeepLink();
  HideLoading();
  useEffect(() => {
    if (Platform.OS !== 'web') {
      SyncTime(dispatch);
    }
  }, []);

  //Show the message and notification of the suggestion to watch educational videos
  //only in the first installation of the application.
  useEffect(() => {
    if (isFirstOpen && isLearnNotifVisible) {
      dispatch(
        getUser({
          isFirstOpen: false,
        }),
      );
    }
  }, []);

  //set vehicle and station route initial loading state
  useEffect(() => {
    dispatch(
      getVehicleslist({
        vehicleIsLoading: true,
        stationIsLoading: true,
      }),
    );
  }, []);

  useEffect(() => {
    if (
      (userStatus === 'new_user_verified' ||
        userStatus === 'inquiry_submitted' ||
        userStatus === 'inquiry_verified' ||
        userStatus === 'inquiry_rejected' ||
        userStatus === 'duplicated_nat' ||
        userStatus === 'profile_submitted' ||
        userStatus === 'profile_rejected' ||
        userStatus === 'active') &&
      token
    ) {
      startReloadVehicleList();
    } else {
      if (!!token) {
        reloadVehicleList();
      }
    }
  }, [userStatus, token]);

  useEffect(() => {
    dispatch(getVehicleslist({type: 'both'}));
    if (!token) {
      stopReloadVehicleList();
    } else {
      checkPermitionAndGetPosition({
        onSuccess: position => {
          vehiclesMutation.mutate({
            ulat: position.coords?.latitude,
            ulng: position.coords?.longitude,
          });
        },
      });
    }
  }, [token]);

  const [title, setTitle] = useState(t('html_title_default'));

  useEffect(() => {
    if (Platform.OS === 'web') {
      setTitle(t(HTMLTitle?.[location?.pathname]) ?? t(html_title_default));
    }
  }, [location?.pathname]);

  const profileMutation = useMutation({
    mutationFn: async () => {
      return api.profile();
    },
    onSuccess: response => {
      let data = response?.Data;
      dispatch(
        getUser({
          info: data,
          mobile: data?.phone_number,
          userStatus: data?.status,
          wallet_credit: data?.wallet_credit,
          deposit_credit: data?.deposit_credit,
          BirthDate: data?.birth_date,
          gender: data?.gender,
          allowedToRideVehicles: data?.allowedToRideVehicles,
        }),
      );
      setNotifications(data?.notifications);
    },
  });

  useEffect(() => {
    if (!!token) {
      profileMutation.mutate();
    }
  }, [token]);

  useEffect(() => {
    if (!isWeb) return;
    if (notifications?.length > 0) {
      notifications?.map(notification => {
        switch (notification.type) {
          case 'auto_penalty_trip': {
            const data = {
              modal: true,
              image: 'tripbillfine',
              width: 90,
              height: 65,
              text: t('non_payment_general_alert'),
              Notification: false,
              btntext: t('view_trip'),
              func: 'penalty',
              cancletext: t('i_realized'),
              number: t('cost_trip_deducted'),
            };
            dispatch(getModal(data));
            return dispatch(getNotification({title: notification.title}));
          }
          case 'auto_pay_trip': {
            const data = {
              modal: true,
              image: 'tripbillfine',
              width: 90,
              height: 65,
              text: t('non_payment_general_alert'),
              Notification: false,
              btntext: t('view_trip'),
              func: 'penalty',
              cancletext: t('i_realized'),
              number: t('cost_trip_deducted'),
            };
            dispatch(getModal(data));
            return dispatch(getNotification({title: notification.title}));
          }
          case 'profile_verified': {
            dispatch(getUser({active: true, userStatus: 'active'}));
            const data = {
              modal: true,
              image: 'noidcart',
              width: 88,
              height: 70,
              text: '',
              Notification: true,
              func: 'idcart',
              number: t('national_card_verified'),
            };
            return dispatch(getModal(data));
          }
          case 'profile_rejected': {
            const data = {
              modal: true,
              image: 'noidcart',
              width: 88,
              height: 70,
              text: t('need_upload_national_card'),
              Notification: true,
              btntext: t('upload_image'),
              func: 'noidcart',
              number: t('national_card_fail'),
            };
            return dispatch(getModal(data));
          }
          case 'penalty': {
            const data = {
              modal: true,
              image: 'penaltycart',
              width: 88,
              height: 60,
              text: notification.description,
              Notification: true,
              number: t('penalty_alert'),
            };
            return dispatch(getModal(data));
          }
          case 'prize': {
            profileMutation.mutate();
            const data = {
              modal: true,
              image: 'confrimcharge',
              width: 88,
              height: 60,
              text: notification.description,
              Notification: true,
              number: t('credit_increased'),
            };
            return dispatch(getModal(data));
          }
          case 'trip ended': {
            const data = {
              modal: true,
              image: 'endTripIcon',
              width: 88,
              height: 60,
              text: notification.description,
              Notification: true,
              func: 'tripended',
              number: t('admin_end_trip'),
            };
            dispatch(getModal(data));
            dispatch(
              getVehicle({
                activeSeconds: 0,
                pauseSeconds: 0,
                activeMinutes: 0,
                pauseMinutes: 0,
                stop: false,
              }),
            );
            return dispatch(getVehicleslist({type: 'both'}));
          }
          default:
            return 0;
        }
      });
    }
    return () => {
      setNotifications(null);
    };
  }, [notifications, userStatus]);

  if (Platform.OS === 'web') {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {props.children}
      </>
    );
  } else {
    return <>{props.children}</>;
  }
};

export default UIWrapper;
